// export default CurriculumSection;
// components/course/CurriculumSection.js
import CurriculumSubsection from './CurriculumSubsection';
import "../css/CurriculumSection.css"

function CurriculumSection({ 
    section, 
    sectionIndex, 
    expandedSubsections, 
    onToggleSubsection, 
    onPlayPreviewVideo 
}) {
    return (
        <div className="curriculum-section">
            {/* Directly render all subsections without section header */}
            {section.subsections && section.subsections.map((subsection, subIndex) => (
                <CurriculumSubsection
                    key={subsection.id}
                    subsection={subsection}
                    sectionIndex={sectionIndex}
                    subIndex={subIndex}
                    isExpanded={expandedSubsections.has(subsection.id)}
                    onToggleSubsection={() => onToggleSubsection(subsection.id)}
                    onPlayPreviewVideo={onPlayPreviewVideo}
                />
            ))}
        </div>
    );
}

export default CurriculumSection;